export const GradientColors = () => {
  const hue = Math.floor(Math.random() * 360);
  const saturation = 70;
  const lightness = 50;

  return {
    color: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
  };
};

// Function to generate unique gradient colors dynamically
export const generateHSLGradient = (index: number) => {
  const baseHue = (94 + index * 60) % 360; // Vary hue significantly for each index
  const startColor = `hsl(${baseHue}, 80%, 55%)`; // Brighter top color
  const endColor = `hsl(${baseHue}, 80%, 35%)`; // Darker bottom color

  return {
    id: `gradient-${index}`,
    startColor,
    endColor,
  };
};

// ✅ Using `generateHSLGradient` in `getRandomColor`
export const getRandomColor = (index: number) => {
  const gradient = generateHSLGradient(index); // Get gradient colors for index

  return {
    solidColor: gradient.startColor, // Use the brighter gradient color as a solid option
    gradient, // Return gradient object if needed
  };
};
